module.exports = __webpack_public_path__ + "media/bootstrap-icons/basket-6b077823.svg";